<template>
  <div>
    <m-update-site-message-1/>

    <b-container fluid class="my-5">
      <slot></slot>
    </b-container>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import {getBaseDomain} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "SiteLayout",
  components: {Header, Footer,},
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated'
    })
  },
  methods: {
    getBaseDomain,
    redirectUser() {
      window.location.href = this.getBaseDomain()
    }
  }
}
</script>

<style scoped>

</style>